import React from 'react';
import history from '../../../../history';
import { PanelGroup, Panel } from '../../compat/PanelCompat';
import PackageUsersNoPrice from '../../packageUsersNoPrice';
import CommercialPackageZones from './commercialPackageZones';
import UsersDefault from '../../../../image/Icons/Users-default.svg';
import UsersActive from '../../../../image/Icons/Users-active.svg';
import ZonesDefault from '../../../../image/Icons/Zones-default.svg';
import ZonesActive from '../../../../image/Icons/Zones-active.svg';

const defaultNumberOfUsers = 3
export default class CommercialProductPackageConfiguration extends React.Component {
  constructor(props) {
    super(props);
    this.handleSelect = this.handleSelect.bind(this);
    this.onSelectingUser = this.onSelectingUser.bind(this);
    this.onUserClickAction = this.onUserClickAction.bind(this);

    this.onSelectingCommercialGeography = this.props.onSelectingCommercialGeography.bind(this);
    this.onGeographyClickAction = this.onGeographyClickAction.bind(this);

    this.onAreaSelect = this.onAreaSelect.bind(this);

    this.onRemoveCommercialGeographyPackage =
      this.props.onRemoveCommercialGeographyPackage.bind(this);

    this.state = {
      mobile: false,
      configuration: {},
      area: {
        state: null,
        city: null
      },
      number_of_users: defaultNumberOfUsers,
      city: '',
      state: '',
      addedItem: false
    };
    this.state.activeKey = this.props.productQuote?.lineItems?.length>0 ?  '2':'1'
  }
  /* istanbul ignore next */
  componentDidMount() {
    if (/Android|webOS|iPhone|iPod|ipad|BlackBerry/i.test(navigator.userAgent)) {
      this.setState({
        mobile: true
      });
    }
  }

  /* istanbul ignore next */
  handleSelect(activeKey) {
    if(!this.props.productQuote?.lineItems?.length > 0) this.setState({ activeKey });
  }

  /* istanbul ignore next */
  onUserClickAction() {
    this.setState({ activeKey: '2' });
  }

  /* istanbul ignore next */
  onGeographyClickAction() {
    this.setState({ activeKey: '0' });
  }

  /* istanbul ignore next */
  addToOrder(area, users) {
    this.props.onSelectingCommercialGeography(area, users);
    this.setState({
      addedItem: true,
      state: '',
      city: '',
      area: {}
    });
  }

  /* istanbul ignore next */
  onAreaSelect(city, state) {
    let area = {
      state: null,
      city: null
    };
    area.state = state;
    area.city = city;
    this.addToOrder(area, this.state.number_of_users);
  }

  /* istanbul ignore next */
  onSelectingUser(user) {
    this.setState({
      number_of_users: user
    });
  }

  render(props) {
    let numberOfRegions = this.state.number_of_users > defaultNumberOfUsers 
      ? this.props.productQuote?.lineItems?.length-1 
      : this.props.productQuote?.lineItems?.length
    if(this.props.isCommercialCombo) numberOfRegions = numberOfRegions-(this.props.productQuote?.lineItems?.length/2)
    return (
      <div>
        <div className='row no-margin'>
          <div className='col-sm-12'>
            <div className='row'>
              <div className='back-btn' onClick={history.goBack}>
                {' '}
                &lt; Back{' '}
              </div>
              <hr />
            </div>
            <div className='row'>
              <div className='section-no-pad-title text-center'>Customise Your Subscription</div>
            </div>
          </div>
        </div>
        <div className='row white-bg padding-20'>
          <div className='col-sm-12 no-padding'>
            <PanelGroup
              accordion
              id='product-config-accordion'
              activeKey={this.state.activeKey}
              onSelect={this.handleSelect}
            >
              <Panel eventKey='1'>
                <Panel.Heading className='white-bg'>
                  <Panel.Title toggle>
                    <div type='button' className='row panel-title panel-button no-margin'>
                      <div className='col-xs-7 text-left text-success  no-padding'>
                        {this.state.number_of_users === '' && (
                          <span>
                            <img src={UsersDefault} alt='' className='margin-right-5' />
                            Users
                          </span>
                        )}
                        {this.state.number_of_users !== '' && (
                          <span>
                            <img src={UsersActive} alt='' className='margin-right-5' />
                            <span className='text-success'>Users</span>
                          </span>
                        )}
                      </div>
                      <div className='col-xs-5 text-right text-success no-padding '>
                        {this.state.number_of_users !== '' && (
                          <span style={{"lineHeight": "30px"}}>
                            {this.state.number_of_users}{' '}
                            {this.state.number_of_users === 1 ? 'User' : 'Users'}{' '}
                          </span>
                        )}
                        {this.state.activeKey !== '1' && (
                          <span
                            className='panel-dropdown-icon carat-down text-success'
                            aria-hidden='true'
                          ></span>
                        )}
                        {this.state.activeKey === '1' && (
                          <span className='panel-dropdown-icon carat-up text-success' aria-hidden='true'></span>
                        )}
                      </div>
                    </div>
                  </Panel.Title>
                </Panel.Heading>
                <Panel.Body collapsible>
                  <PackageUsersNoPrice
                    selectedUser={
                      this.props.productPackageDefaultConfig.configuration.number_of_users
                    }
                    onSelectingUser={this.onSelectingUser}
                    onUserClickAction={this.onUserClickAction}
                    minimumUsers={3}
                  />
                </Panel.Body>
              </Panel>
              <Panel eventKey='2'>
                <Panel.Heading className='white-bg'>
                  <Panel.Title toggle>
                    <div type='button' className='row panel-title panel-button no-margin'>
                      <div className='col-xs-8 text-left  no-padding'>
                        {!this.props.productPackageDefaultConfig.configuration.packages.length > 0 &&
                        (this.state.city === '' || this.state.state === '') && (
                          <span>
                            <img src={ZonesDefault} alt='' className='margin-right-5' />
                            <span className={this.state.activeKey !== '2' ? 'tan-text': ''}>Areas</span>
                          </span>
                        )}
                        {(this.props.productPackageDefaultConfig.configuration.packages.length > 0
                          || (this.state.city !== '' && this.state.state !== '')
                          ) && (
                          <span>
                            <img src={ZonesActive} alt='' className='margin-right-5' />
                            <span className='text-success'>Areas</span>
                          </span>
                        )}
                      </div>
                      <div className='col-xs-4 text-right no-padding'>
                        {this.state.city !== '' && this.state.state !== '' && (
                          <span className='margin-right-5 text-success'>
                            {this.state.city},{' '}
                            <span className='text-uppercase'>{this.state.state}</span>
                          </span>
                        )}
                        {this.props.productQuote &&
                          this.props.productQuote.lineItems &&
                          this.props.productQuote.lineItems.length === 0 && (
                            <span className='margin-right-5' style={{ color: '#FF9900' }}>
                              <i className='fas fa-exclamation-circle margin-right-5'></i>
                              No area selected
                            </span>
                          )}
                        {this.props.productQuote &&
                          this.props.productQuote.lineItems &&
                          this.props.productQuote.lineItems.length > 0 && (
                            <span style={{"lineHeight": "30px"}} className='margin-right-5 text-success'>
                              {numberOfRegions}{' '}
                              {numberOfRegions > 1 ? 'Regions' : 'Region'}
                            </span>
                          )}
                        {this.state.activeKey !== '2' &&
                          (this.state.city === '' || this.state.state === '') && (
                            <span className='panel-dropdown-icon carat-down' aria-hidden='true'></span>
                          )}
                        {this.state.activeKey === '2' &&
                          (this.state.city === '' || this.state.state === '') && (
                            <span className='panel-dropdown-icon carat-up' aria-hidden='true'></span>
                          )}
                        {this.state.activeKey !== '2' &&
                          this.state.city !== '' &&
                          this.state.state !== '' && (
                            <span
                              className='panel-dropdown-icon carat-down text-success'
                              aria-hidden='true'
                            ></span>
                          )}
                        {this.state.activeKey === '2' &&
                          this.state.city !== '' &&
                          this.state.state !== '' && (
                            <span
                              className='panel-dropdown-icon carat-up text-success'
                              aria-hidden='true'
                            ></span>
                          )}
                      </div>
                    </div>
                  </Panel.Title>
                </Panel.Heading>
                <Panel.Body collapsible>
                  <CommercialPackageZones
                    addedItem={this.state.addedItem}
                    geography={this.props.productPackageConfig.location}
                    onAreaSelect={this.onAreaSelect}
                    onGeographyClickAction={this.onGeographyClickAction}
                    onRemoveCommercialGeographyPackage={this.onRemoveCommercialGeographyPackage}
                    onSelectingCommercialGeography={this.onSelectingCommercialGeography}
                    packageKey={this.props.productPackageDefaultConfig.configuration.package}
                    productQuote={this.props.productQuote}
                    selectedGeography={
                      this.props.productPackageDefaultConfig.configuration.packages
                    }
                    numberOfRegions={numberOfRegions}
                  />
                </Panel.Body>
              </Panel>
            </PanelGroup>
          </div>
        </div>
      </div>
    );
  }
}
